import React from "react";

import { useContextMenuContext } from "@components/ContextMenu/ContextMenu";

interface ContextMenuTriggerProps {
  children: React.ReactNode;
  disabled?: boolean;
}

export const ContextMenuTrigger: React.FC<ContextMenuTriggerProps> = ({ children, disabled = false }) => {
  const ctx = useContextMenuContext();

  return (
    <div
      onContextMenu={(e) => {
        e.preventDefault();
        e.stopPropagation();
        if (disabled) return;
        ctx.open(e.clientX, e.clientY);
      }}
    >
      {children}
    </div>
  );
};
